import React, { createContext, RefObject } from 'react';

interface ContextType extends RefObject<HTMLDivElement> {}

export const BeforeMobileMainMenuRefContext = createContext<ContextType | null>(null);
